import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const AdminSliderServices = {
  getSliders,
  addSliders,
  updateSliders,
  deleteSliders
}

function getSliders () {
  return fetch(API_URL + '/api/admin/v1/slider', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function addSliders (postdata) {
  return fetch(API_URL + '/api/admin/v1/slider', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateSliders (postdata) {
  return fetch(API_URL + '/api/admin/v1/slider', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteSliders (id) {
  return fetch(API_URL + '/api/admin/v1/slider/' + id, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
